import { FC, Key, ReactNode } from 'react'
import { useMobileDetector } from '../../hooks/use-mobile-detector'
import PdMedia from '../pd-media/pd-media'
import { title } from 'process'
import TitleBar, { TitleBarTheme } from './title-bar'
import { HeadingTag, SemanticTextTag } from '../../common/pd-meta-components-types'
import SemanticText from '../standard/semantic-text'

type InlineMediaDescProps = {
  title?: string[]
  titleTag?: HeadingTag
  itemTitleTag?: HeadingTag
  itemInfoTag?: SemanticTextTag
  desc?: string[]
  data: {
    mediaUri: string
    mediaClassName?: string
    mediaStyle?: { [key in string]: Key }
    title?: string[]
    titleSize?: string
    desc?: string[]
    infoGroup?: { data: string; desc: string }[]
    reverseCondition?: boolean
  }[]
  theme?: TitleBarTheme
}

const InlineMediaDesc: FC<InlineMediaDescProps> = ({
  data,
  title,
  titleTag,
  itemTitleTag,
  itemInfoTag,
  desc,
  theme = TitleBarTheme.black,
}) => {
  const isMobileDevice = useMobileDetector()

  return (
    <div
      className={[
        theme === TitleBarTheme.black ? 'bg-black' : 'bg-white',
        'w-full h-fit  py-15 px-6',
        'laptop:py-30 laptop:px-0',
      ].join(' ')}
    >
      {title && (
        <TitleBar
          title={title}
          titleTag={titleTag}
          desc={desc}
          theme={theme === TitleBarTheme.black ? TitleBarTheme.white : TitleBarTheme.black}
        />
      )}
      <div className={['w-full mx-auto flex flex-col gap-8', 'laptop:w-300 laptop:gap-240px'].join(' ')}>
        {data?.map((item, index) => (
          <div
            key={index}
            className={[
              'flex flex-col gap-5',
              'laptop:flex-row laptop:gap-12',
              item?.reverseCondition && 'flex-col-reverse laptop:flex-row-reverse',
            ].join(' ')}
          >
            <div style={{ ...item?.mediaStyle }} className={['flex-none', item?.mediaClassName].join(' ')}>
              <PdMedia src={item.mediaUri} mask={false} />
            </div>
            <div className={['flex-1', 'flex flex-col gap-5', 'laptop:gap-64px laptop:justify-center'].join(' ')}>
              <div className={[''].join(' ')}>
                {/* title */}
                <div className={['mb-1', 'laptop:mb-6'].join(' ')}>
                  {item?.title?.map((ele, index) => (
                    <SemanticText
                      key={index}
                      as={itemTitleTag}
                      defaultTag="h3"
                      className={[
                        theme === TitleBarTheme.black ? 'text-white/90' : 'text-black /90',
                        'font-semibold',
                        item?.titleSize || 'laptop:text-40 text-16',
                      ].join(' ')}
                    >
                      {ele}
                    </SemanticText>
                  ))}
                </div>
                {/* desc */}
                <div className={[].join(' ')}>
                  {item?.desc?.map((item, index) => (
                    <p
                      key={index}
                      className={[
                        theme === TitleBarTheme.black ? 'text-white/90' : 'text-black /90',
                        ' text-14',
                        'laptop:text-18',
                        '',
                      ].join(' ')}
                    >
                      {item}
                    </p>
                  ))}
                </div>
              </div>
              <div className={['flex justify-between laptop:gap-64px laptop:justify-start'].join(' ')}>
                {item?.infoGroup?.map((ele, idx) => (
                  <div key={idx} className={['w-[50%] flex flex-col gap-1', 'laptop:w-fit laptop:gap-2'].join(' ')}>
                    <SemanticText
                      as={itemInfoTag}
                      defaultTag="h2"
                      className={["text-[#BCCF11] text-28 font-bold font-['Montserrat']", 'laptop:text-48'].join(' ')}
                    >
                      {ele?.data}
                    </SemanticText>
                    <p
                      className={[
                        theme === TitleBarTheme.black ? 'text-white/60' : 'text-black /60',
                        ' text-14',
                        'laptop:text-16',
                      ].join(' ')}
                    >
                      {ele?.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default InlineMediaDesc
